/**
 * @generated SignedSource<<cca8185d4e99740aa617bbb52991dbaf>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraGoalStatus = "ARCHIVED" | "AT_RISK" | "CANCELLED" | "COMPLETED" | "DONE" | "OFF_TRACK" | "ON_TRACK" | "PAUSED" | "PENDING" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type goals_issueFieldGoalsReadviewFull_GoalsReadView$data = {
  readonly selectedGoals: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly key: string | null | undefined;
        readonly name?: string | null | undefined;
        readonly status?: JiraGoalStatus | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"popupContent_issueFieldGoalsReadviewFull">;
  } | null | undefined;
  readonly " $fragmentType": "goals_issueFieldGoalsReadviewFull_GoalsReadView";
};
export type goals_issueFieldGoalsReadviewFull_GoalsReadView$key = {
  readonly " $data"?: goals_issueFieldGoalsReadviewFull_GoalsReadView$data;
  readonly " $fragmentSpreads": FragmentRefs<"goals_issueFieldGoalsReadviewFull_GoalsReadView">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "goals_issueFieldGoalsReadviewFull_GoalsReadView",
  "selections": [
    {
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1000
        }
      ],
      "concreteType": "JiraGoalConnection",
      "kind": "LinkedField",
      "name": "selectedGoals",
      "plural": false,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "popupContent_issueFieldGoalsReadviewFull"
        },
        {
          "concreteType": "JiraGoalEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraGoal",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "id"
                },
                {
                  "kind": "ScalarField",
                  "name": "key"
                },
                {
                  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "name"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "status"
                    }
                  ]
                }
              ]
            }
          ]
        }
      ],
      "storageKey": "selectedGoals(first:1000)"
    }
  ],
  "type": "JiraGoalsField"
};

(node as any).hash = "e8e15ade4d6e6ee4a59b31ff82e7a584";

export default node;
